module.exports = __webpack_public_path__ + "09c899a45fc9ecf716a015173f4af5bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/login-bg.jpg
// module id = 3070
// module chunks = 2